import {
  AttachmentTypeEnum,
  ContactDetail,
  Conversation,
  ConversationDirection,
  ConversationItem,
  ConversationTypeEnum,
  Environment,
  EventResultEnum,
  LeadStatusType,
  PendingEndlink,
  ReplyOption,
  SystemOfRecord
} from "@coxauto-ui/cxm/communications/interfaces";
import {
  IConversationDetailsContext,
  ICustomerConversationContext,
  IEmailReplyContext,
  IPhoneReplyContext,
  ITextReplyContext
} from "./index";

export const mockReplyOptions: ReplyOption[] = [
  {
    // detail: "testemail@testemail.com",
    replyInline: true,
    replyUrl: "https://www.coxautoinc.com/",
    type: ConversationTypeEnum.EMAIL
  },
  {
    // detail: "+1 (310) 885-4602",
    replyInline: false,
    replyUrl: "https://www.coxautoinc.com/",
    type: ConversationTypeEnum.TEXT
  },
  {
    // detail: "+1 (310) 885-4602",
    replyInline: false,
    replyUrl: "https://www.coxautoinc.com/",
    type: ConversationTypeEnum.PHONE
  },
  {
    // detail: "inline",
    replyInline: true,
    type: ConversationTypeEnum.CHAT
  }
];

export const attachmentScratchpad = [
  {
    key: "MyFileKey",
    contentType: "image/jpeg",
    fileName: "TheBestFile.jpeg",
    fileSize: 14,
    token: "ThisIsMySecureToken"
  },
  {
    key: "MyFileKey2",
    contentType: "image/jpeg",
    fileName: "TheBestFile2.jpeg",
    fileSize: 16,
    token: "ThisIsMySecureToken2"
  }
];

export const onClickMessage = async (selectedMessage: ConversationItem) => {
  return;
};

export const getAdditionalMessageDetail = async (key: number) => {
  return new Promise<string>(resolve =>
    resolve(
      "This is where the additional message content would be if we were really calling an API, but this is just storybook so you only get this"
    )
  );
};
export const conversationDataProps: Conversation = {
  nextItem: 8,
  conversation: [
    {
      age: "delivered 19 min ago",
      direction: ConversationDirection.Outbound,
      content: { text: "Hello, how can I help?" },
      senderName: "Chicken Mc Nugget",
      senderContactInfo: "",
      date: "03-14-2024 02:09:32",
      type: ConversationTypeEnum.TEXT,
      key: 0,
      phoneNumber: "",
      emailAddress: "",
      eventResult: EventResultEnum.SUCCESS,
      attachments: [],
      provider: "XTI"
    },
    {
      age: "17 min ago",
      direction: ConversationDirection.Inbound,
      content: {
        text: "Hello! I would like to know how much my car is worth as a trade in, can we do a phone call?"
      },
      senderName: "Mike Heady",
      senderContactInfo: "",
      date: "03-14-2024 02:10:32",
      type: ConversationTypeEnum.TEXT,
      key: 1,
      phoneNumber: "",
      emailAddress: "",
      eventResult: EventResultEnum.SUCCESS,
      attachments: [
        {
          attachmentId: "1212",
          fileName: "MyFile.jpg",
          type: AttachmentTypeEnum.IMAGE
        },
        {
          attachmentId: "",
          fileName: "",
          type: AttachmentTypeEnum.VIDEO,
          url: "https://mock-testing-player.vin.media/?src=https%3a%2f%2fqa.video.vin.media%2fCxm-Occ-Bff%2fshort%2f4f402b97-55b3-4c2d-a970-e37fe459a131"
        },
        {
          attachmentId: "1213",
          fileName: "MyFile.mp4",
          type: AttachmentTypeEnum.AUDIO
        },
        {
          attachmentId: "1214",
          fileName: "MyReport.pdf",
          type: AttachmentTypeEnum.OTHER,
          url: "https://s3.presigned.example.com/MyReport.pdf?X-Amz-Signature=abc123"
        },
        {
          attachmentId: "1215",
          fileName: "MyPhoto.png",
          type: AttachmentTypeEnum.IMAGE,
          url: "https://s3.presigned.example.com/MyPhoto.png?X-Amz-Signature=def456"
        }
      ]
    },
    {
      age: "delivered 16 min ago",
      direction: ConversationDirection.Outbound,
      content: {
        text: "Sure we can set up a phone call, do you have some time right now?"
      },
      senderName: "Nick Bargeman",
      senderContactInfo: "",
      date: "03-14-2024 02:11:32",
      type: ConversationTypeEnum.TEXT,
      key: 2,
      phoneNumber: "",
      emailAddress: "",
      eventResult: EventResultEnum.SUCCESS,
      attachments: [
        {
          attachmentId: "1213",
          fileName: "MyFile.jpg",
          type: AttachmentTypeEnum.IMAGE
        }
      ],
      provider: "VIN"
    },
    {
      age: "22 min ago",
      direction: ConversationDirection.Inbound,
      content: {
        text: "Inbound call",
        callUrl:
          "https://filesamples.com/samples/audio/mp3/Symphony%20No.6%20(1st%20movement).mp3"
      },
      senderName: "Mike Heady",
      senderContactInfo: "",
      date: "03-14-2024 02:12:32",
      type: ConversationTypeEnum.PHONE,
      key: 3,
      phoneNumber: "",
      emailAddress: "",
      eventResult: EventResultEnum.SUCCESS,
      attachments: [],
      provider: "XTI"
    },
    {
      age: "22 min ago",
      direction: ConversationDirection.Outbound,
      content: {
        text: "Outbound call from banana phone",
        callUrl: "https://filesamples.com/samples/audio/mp3/sample1.mp3"
      },
      senderName: "Michelle Foster",
      senderContactInfo: "",
      date: "03-14-2024 02:12:32",
      type: ConversationTypeEnum.PHONE,
      key: 4,
      phoneNumber: "",
      emailAddress: "",
      eventResult: EventResultEnum.SUCCESS,
      attachments: [],
      provider: "XTI"
    },
    {
      age: "1 min ago",
      direction: ConversationDirection.Outbound,
      content: {
        text: "External service wants to say something",
        externalUrl: "https://www.coxautoinc.com/"
      },
      senderName: "Some external dude",
      senderContactInfo: "",
      date: "03-14-2024 02:12:32",
      type: ConversationTypeEnum.EMAIL,
      key: 5,
      phoneNumber: "",
      emailAddress: "",
      eventResult: EventResultEnum.SUCCESS,
      attachments: []
    },
    {
      age: "seconds ago",
      direction: ConversationDirection.Inbound,
      content: {
        text: "Hello World"
      },
      senderName: "Mike Heady",
      senderContactInfo: "",
      date: "03-14-2024 02:12:32",
      type: ConversationTypeEnum.CHAT,
      key: 6,
      phoneNumber: "",
      emailAddress: "",
      eventResult: EventResultEnum.SUCCESS,
      attachments: []
    },
    {
      age: "1 min ago",
      direction: ConversationDirection.Inbound,
      content: {
        text: "External service wants to say something",
        externalUrl: "https://www.coxautoinc.com/"
      },
      senderName: "Some external dude",
      senderContactInfo: "testmail@mail.com",
      date: "03-14-2024 02:12:32",
      type: ConversationTypeEnum.EMAIL,
      key: 5,
      phoneNumber: "",
      emailAddress: "",
      eventResult: EventResultEnum.SUCCESS,
      attachments: []
    },
    {
      age: "1 min ago",
      direction: ConversationDirection.Outbound,
      content: {
        text: "External service wants to say something",
        externalUrl: "https://www.coxautoinc.com/"
      },
      senderName: "Some external dude",
      senderContactInfo: "testmail@mail.com",
      date: "03-14-2024 02:12:32",
      type: ConversationTypeEnum.EMAIL,
      key: 5,
      phoneNumber: "",
      emailAddress: "",
      eventResult: EventResultEnum.FAILED,
      attachments: []
    }
  ],
  recentContactText: "",
  recentContactEmail: "",
  xSignature: "MySignature001"
};

export const mockConversationContextProvider: ICustomerConversationContext = {
  activeListTab: ConversationTypeEnum.EMAIL,
  autoLeadId: null,
  autoLeadStatus: LeadStatusType.ACTIVE,
  leadStatusError: false,
  repairOrderId: null,
  contactDetails: {
    consumerId: "abc-123",
    name: {
      first: "Jim",
      last: "Jam",
      fullName: "Jim Jam"
    },
    replyOptions: mockReplyOptions,
    contactChannels: {} as Record<ConversationTypeEnum, ContactDetail[]>
  },
  customerId: "abc-123",
  customerName: "Jim Jam",
  customerSystem: SystemOfRecord.COMMON,
  commonOrgId: "org-123",
  dealerCommunicationDetails: {
    dealerPhoneNumber: {
      phoneNumber: "555-5555",
      campaignApproved: false,
      isPhoneNumberReady: false,
      canProceed: false
    },
    userPhoneNumbers: [
      {
        phoneNumber: "555-5555",
        userFullName: "John Doe",
        campaignApproved: false,
        isPhoneNumberReady: false,
        canProceed: false
      }
    ]
  },
  disableReply: false,
  hasActiveTask: false,
  defaultMessageContent: null,
  defaultTab: null,
  env: Environment.none,
  error: "",
  contactDetailsError: "",
  contactDetailsErrorDetails: undefined,
  isGenerativeAIEnabled: false,
  occConfig: {
    username: "",
    disableReply: false,
    defaultTab: undefined,
    messageContent: undefined
  },
  replyOptions: mockReplyOptions,
  title: "",
  taskId: null,
  templateId: null,
  serviceAppointmentId: null,
  showCustomerInfo: true,
  inboxMessageHandler: undefined,
  isIframeMode: false,
  setActiveListTab: () => "",
  setError: () => "",
  getUserName: () => "User Name",
  setDefaultMessageContent: () => null,
  vinDealerId: 123,
  bridgeUserId: null,
  completeTask: () => null,
  refreshContactDetails: () => undefined
};

export const mockConversationDetailsContextProvider: IConversationDetailsContext =
  {
    conversationItems: conversationDataProps.conversation,
    displayConversationItems: conversationDataProps.conversation,
    selectedConversationItem: conversationDataProps.conversation[0],
    recentContactEmail: "test123@example.com",
    recentContactText: "8165551245",
    xSignature: "MySignature001",
    latestConversationItemType: ConversationTypeEnum.ALL,
    currentConversationType: ConversationTypeEnum.ALL,
    setConversationItems: () => "",
    setDisplayConversationItems: () => "",
    setSelectedConversationItem: () => "",
    setRecentContactEmail: () => "",
    setRecentContactText: () => "",
    setXSignature: () => "",
    setLatestConversationItemType: () => "",
    setCurrentConversationType: () => "",
    showGenerativeAI: true,
    isSuggestEdit: false,
    emojiPickerError: false,
    signatureInsertError: null,
    selectedReplyOption: mockReplyOptions[0],
    setShowGenerativeAI: () => false,
    setIsSuggestEdit: () => false,
    setEmojiPickerError: () => false,
    setSignatureInsertError: () => null,
    setSelectedReplyOption: () => "",
    toggleSetShowReply: () => ""
  };

export const mockEmailReplyContextProvider: IEmailReplyContext = {
  replyText: "Email reply text",
  replyTextSubject: "RE: Email subject",
  attachments: attachmentScratchpad,
  selectedToChannelValue: "test@example.com",
  selectedStationeryHTML: "<p>This is some stationery</p>",
  templateHead: "<head><style>p { color: red; }</style></head>",
  selectedTemplateLoadState: {
    hasLoaded: false,
    loadedTemplateId: null
  },
  ccRecipients: [],
  bccRecipients: [],
  selectedMedia: [],
  endlinkMediaMap: {},
  setReplyText: () => "",
  setReplyTextSubject: () => "",
  setAttachments: () => [],
  setSelectedToChannelValue: () => "",
  setSelectedStationeryHTML: () => "",
  setTemplateHead: () => "",
  setSelectedTemplateLoadState: () => "",
  setCcRecipients: () => [],
  setBccRecipients: () => [],
  setSelectedMedia: () => [],
  setEndlinkMediaMap: () => ({})
};

export const mockTextReplyContextProvider: ITextReplyContext = {
  replyText: "Text reply message",
  attachments: attachmentScratchpad,
  selectedDealerPhoneInformation: {
    phoneNumber: "+15551234567",
    validation: {
      canProceed: true,
      campaignApproved: true,
      isPhoneNumberReady: true
    }
  },
  selectedToChannelValue: "+15559876543",
  selectedTemplateLoadState: {
    hasLoaded: false,
    loadedTemplateId: null
  },
  isTextOptInPending: false,
  isPhoneValidationBlocking: false,
  selectedMedia: [],
  pendingEndlinks: [],
  setReplyText: () => "",
  setAttachments: () => [],
  setSelectedDealerPhoneInformation: () => undefined,
  setSelectedToChannelValue: () => "",
  setSelectedTemplateLoadState: () => "",
  setIsTextOptInPending: () => "",
  setSelectedMedia: () => [],
  setPendingEndlinks: () => []
};

export const mockPendingEndlink = (
  overrides: Partial<PendingEndlink> = {}
): PendingEndlink => ({
  chipId: `chip-${overrides.mediaId ?? "1"}`,
  mediaId: "media-1",
  mediaViewTrackingId: "tracking-1",
  title: "Video Title 1",
  endLink: "https://truevideo.com/endlink/1",
  thumbnail: "https://cdn.example.com/thumb-1.jpg",
  ...overrides
});

export const mockPendingEndlinks: PendingEndlink[] = [1, 2, 3].map(n => ({
  chipId: `chip-${n}`,
  mediaId: `media-${n}`,
  mediaViewTrackingId: `tracking-${n}`,
  title: `Video Title ${n}`,
  endLink: `https://truevideo.com/endlink/${n}`,
  thumbnail: `https://cdn.example.com/thumb-${n}.jpg`
}));

export const mockPhoneReplyContextProvider: IPhoneReplyContext = {
  replyText: "Phone call notes",
  messageCallContacted: "SPOKE",
  messageCallType: ConversationDirection.Inbound,
  selectedToChannelValue: "+15559876543",
  setReplyText: () => "",
  setMessageCallContacted: () => "",
  setMessageCallType: () => "",
  setSelectedToChannelValue: () => ""
};
